import { FC, PropsWithChildren } from 'react'

import { useUnit } from 'effector-react'

import { $isFileDropping } from './models'

export const DropzoneIndicationWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  const isFileDropping = useUnit($isFileDropping)

  return (
    <div className="relative w-full">
      {isFileDropping && (
        <div className="bg-primary-700 absolute left-0 top-0 flex h-full w-full items-center justify-center text-lg font-bold uppercase text-white">
          Drop files to upload
        </div>
      )}
      {children}
    </div>
  )
}
